module.exports = __webpack_public_path__ + "media/images/icon-reddot-8ab1efbef5071ebde26375505cd67519.svg";